import { useParams } from 'react-router-dom';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import ErrorPage from './ErrorPage';
import { useEffect, useState, lazy, Suspense } from 'react';
import Loader from '../components/Loader';

const FormEdit = lazy(() => import('../components/FormEdit'));

const ClinicMaterialsForm = () => {
  const [isTooSmall, setIsTooSmall] = useState(window.innerWidth < 770);

  useEffect(() => {
    const handleResize = () => {
      setIsTooSmall(window.innerWidth < 770);
    };

    window.addEventListener('resize', handleResize);

    // limpa o listener ao desmontar
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const { id } = useParams<{ id: string }>();

  if (isTooSmall) return <ErrorPage code={404} />

  return (
    <DndProvider backend={HTML5Backend}>
      <Suspense fallback={<Loader />}>
        {/* Verifica se o ID é válido antes de renderizar o componente FormEdit */}
        <FormEdit formId={id !== 'new' ? id : undefined} />
      </Suspense>
    </DndProvider>
  );
};

export default ClinicMaterialsForm;
